import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-confirmacion',
  templateUrl: './dialog-confirmacion.component.html',
  styleUrls: ['./dialog-confirmacion.component.css']
})
export class DialogConfirmacionComponent implements OnInit {

  mensaje: string;

  constructor(public dialogRef: MatDialogRef<DialogConfirmacionComponent>) { }

  ngOnInit()
  {
  }

  confirmar(): void
  {
    this.dialogRef.close(true);
  }

  cancelar(): void
  {
    this.dialogRef.close(false);
  }

}
